var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillOpacity: 0.6,
  d: "M12.063 3.936h3.048v11.175H3.936v-3.048H.89V.89h11.174zm0 2.032v6.095H5.968v1.016h7.111V5.968zM2.92 2.92v7.111h7.111v-7.11z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export { SvgCopy as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzMzMl8yOTg3KSI+CjxwYXRoIGQ9Ik0xMi4wNjMzIDMuOTM2MjlIMTUuMTEwOVYxNS4xMTA5SDMuOTM2MjlWMTIuMDYzM0gwLjg4ODY3MlYwLjg4ODY3MkgxMi4wNjMzVjMuOTM2MjlaTTEyLjA2MzMgNS45NjgwNFYxMi4wNjMzSDUuOTY4MDRWMTMuMDc5MUgxMy4wNzkxVjUuOTY4MDRIMTIuMDYzM1pNMi45MjA0MiAyLjkyMDQyVjEwLjAzMTVIMTAuMDMxNVYyLjkyMDQySDIuOTIwNDJaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC42Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMzMyXzI5ODciPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";